import React from 'react';

let Section = (props) => {
    return <div className="section">
        <div className="section-header">
            <h2>{props.name}</h2>
        </div>
        <div className="section-content">
            {props.children}
        </div>
    </div>
}

// Returns url when it is safe to put in an href or hand to window.open, and
// null otherwise.
//
// Site URLs reach the page from places a stranger can influence -- the popup
// fills one straight from its ?url= query parameter -- and a "javascript:" URL
// in either sink runs in this origin, where the auth token lives. Verified in
// Chromium: window.open("javascript:...", "_blank") executes.
//
// The scheme is read with the browser's own URL parser rather than a prefix
// check, so it is normalised exactly as a navigation would be: leading spaces
// stripped and tabs and newlines deleted. "java<TAB>script:" is javascript: to
// a browser and would slip past a string match.
//
// A value with no scheme at all -- a bare "www.example.com", which is much of
// what is stored -- stays allowed: as an href the browser treats it as a
// relative path, which is not a working link but cannot run anything, and it
// is what was rendered before.
//
// It is resolved against a fixed base rather than window.location.origin, so
// the verdict does not depend on the page. A page with an opaque origin (a
// file:// page, a sandboxed frame) reports its origin as "null", which is not
// a valid base: bare text would throw and be refused there while allowed here.
// The base only settles whether a scheme is present -- an absolute URL ignores
// it -- and the original string is what is returned, so it never reaches an href.
const SCHEME_PROBE_BASE = 'https://scheme-probe.invalid/';

const safeHref = (url) => {
    if (typeof url !== 'string' || url.trim() === '') return null;

    let parsed;
    try {
        parsed = new URL(url, SCHEME_PROBE_BASE);
    } catch (e) {
        return null;
    }
    return parsed.protocol === 'http:' || parsed.protocol === 'https:' ? url : null;
};

// The API refuses longer notes (api-server.rb NOTES_MAX_CHARS); the column is
// sized for the encrypted form of exactly this many characters.
const NOTES_MAX_CHARS = 2000;

export {
    Section,
    safeHref,
    NOTES_MAX_CHARS
}